//@ts-ignore
import { parse } from 'query-string';
export var BaseTokenEnum;
(function (BaseTokenEnum) {
    BaseTokenEnum["sfContactId"] = "sfContactId";
    BaseTokenEnum["workEmailRoleToken"] = "workEmailRoleToken";
    BaseTokenEnum["workEmailVerifyToken"] = "workEmailVerifyToken";
    BaseTokenEnum["authToken"] = "authToken";
    BaseTokenEnum["userSocialLinkToken"] = "userSocialLinkToken";
})(BaseTokenEnum || (BaseTokenEnum = {}));
export var pickTokensFromSearch = function (locationSearch) {
    var params = parse(locationSearch);
    var tokens = {};
    var possibleTokens = Object.keys(BaseTokenEnum);
    Object.keys(params).forEach(function (paramName) {
        if (possibleTokens.indexOf(paramName) !== -1) {
            tokens[paramName] = params[paramName];
        }
    });
    return tokens;
};
//# sourceMappingURL=tokens.js.map